// extracted by mini-css-extract-plugin
export default {"root":"career-highlights-table_root__yn75g"};